import * as angular from "angular";
import {IController} from "angular";
import {SplitService} from "../../modules/commons/services/split-service.service";

export class LeftSideNavCtrl implements IController {

  private selectedSkin: any;
  private isSmallScreen: any;
  public logoUrl: any;

  /* @ngInject */
  constructor(private $mdMedia, private triSkins, private splitService: SplitService) {
    this.selectedSkin = this.triSkins.getCurrent();
  }

  $onInit() {
     this.logoUrl = this.splitService.getSiteLogoUrl();
  }

  $doCheck() {
    this.isSmallScreen = !this.$mdMedia('gt-md');
  };

}

angular
  .module('bringoz.admin.commons')
  .component('leftSideNav', {
    bindings: {},
    template: require('./left-side-nav.html').default,
    controller: LeftSideNavCtrl
  });
